(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sentubila-madrid-footer"] && !Shopify.designMode) return;
  try {
    
function initMadridFooter(root=document){const mq=matchMedia('(max-width:749px)');root.querySelectorAll('.mr-footer-links').forEach(d=>{d.open=!mq.matches});mq.addEventListener('change',()=>document.querySelectorAll('.mr-footer-links').forEach(d=>{d.open=!mq.matches}));}initMadridFooter();document.addEventListener('shopify:section:load',e=>initMadridFooter(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sentubila-madrid-replica"] && !Shopify.designMode) return;
  try {
    
const madridRails = new WeakMap();
function bindMadridRail(module) {
  const viewport = module.querySelector('[data-mr-rail]');
  const track = module.querySelector('.mr-rail-track');
  const panels = Array.from(track.children);
  if (!panels.length) return;
  const signal = new AbortController();
  const listen = (target, event, fn, options = {}) => target.addEventListener(event, fn, { ...options, signal: signal.signal });
  panels.forEach((panel, index) => {
    panel.dataset.mrRailIndex = index;
    panel.setAttribute('draggable', 'false');
    panel.querySelectorAll('img').forEach(img => img.draggable = false);
  });
  const clones = () => panels.map(panel => {
    const clone = panel.cloneNode(true);
    clone.removeAttribute('data-shopify-editor-block');
    clone.removeAttribute('id');
    clone.dataset.mrRailClone = 'true';
    clone.setAttribute('aria-hidden', 'true');
    clone.tabIndex = -1;
    clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
    return clone;
  });
  track.prepend(...clones());
  track.append(...clones());
  module.classList.add('is-looping');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let width = 1, cycle = 1, offset = 0, hover = false, focus = false;
  let selected = false, visible = true, drag = null, animation = null;
  let frame = 0, previousTime = 0, suppressClickUntil = 0;
  const draw = () => {
    offset = ((offset % cycle) + cycle) % cycle;
    track.style.transform = 'translate3d(' + (-cycle - offset) + 'px,0,0)';
    module.dataset.railIndex = String(Math.floor(offset / width + .001) % panels.length);
  };
  const resize = () => {
    const progress = offset / width;
    const perView = innerWidth >= 1100 ? 2.4 : innerWidth >= 750 ? 2 : 1;
    width = viewport.clientWidth / perView;
    if (!width) return;
    cycle = width * panels.length;
    module.style.setProperty('--mr-rail-width', width + 'px');
    offset = progress * width;
    animation = null;
    draw();
  };
  const moveTo = (target, instant = false) => {
    if (instant || reduced.matches) { offset = target; animation = null; draw(); }
    else animation = { from: offset, to: target, start: performance.now(), duration: 450 };
  };
  const step = direction => {
    animation = null;
    moveTo((Math.round(offset / width) + direction) * width);
  };
  const tick = time => {
    const elapsed = previousTime ? Math.min(time - previousTime, 100) : 0;
    previousTime = time;
    if (animation) {
      const progress = Math.min((time - animation.start) / animation.duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      offset = animation.from + (animation.to - animation.from) * eased;
      if (progress === 1) animation = null;
      draw();
    } else if (panels.length > 1 && visible && !document.hidden && !hover && !focus && !selected && !drag && !reduced.matches) {
      offset += elapsed * width / 20000;
      draw();
    }
    frame = requestAnimationFrame(tick);
  };
  listen(viewport, 'pointerenter', event => { if (event.pointerType === 'mouse') hover = true; });
  listen(module, 'pointerleave', event => { if (event.pointerType === 'mouse') hover = false; });
  listen(module, 'focusin', event => {
    focus = event.target.matches(':focus-visible');
    const panel = event.target.closest('.mr-rail-panel:not([data-mr-rail-clone])');
    if (panel && !drag && focus) moveTo(Number(panel.dataset.mrRailIndex) * width, true);
  });
  listen(module, 'focusout', () => requestAnimationFrame(() => { focus = module.contains(document.activeElement) && document.activeElement.matches(':focus-visible'); }));
  listen(viewport, 'dragstart', event => event.preventDefault());
  listen(viewport, 'pointerdown', event => {
    if (event.button !== 0 || panels.length < 2) return;
    animation = null;
    drag = { id: event.pointerId, x: event.clientX, y: event.clientY, from: offset, dx: 0, active: false };
  });
  listen(viewport, 'pointermove', event => {
    if (!drag || drag.id !== event.pointerId) return;
    const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
    if (!drag.active && Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) { drag = null; return; }
    if (!drag.active && Math.abs(dx) > 6) {
      drag.active = true;
      viewport.setPointerCapture(event.pointerId);
      module.classList.add('is-dragging');
    }
    if (drag.active) {
      event.preventDefault();
      drag.dx = dx;
      offset = drag.from - dx;
      draw();
    }
  });
  const release = event => {
    if (!drag || drag.id !== event.pointerId) return;
    if (drag.active) {
      suppressClickUntil = performance.now() + 600;
      const target = Math.abs(drag.dx) > width * .12
        ? Math.round(drag.from / width) - Math.sign(drag.dx)
        : Math.round(offset / width);
      const nearest = offset + (target * width - (drag.from - drag.dx));
      moveTo(nearest);
      if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
    }
    drag = null;
    module.classList.remove('is-dragging');
  };
  listen(viewport, 'pointerup', release);
  listen(viewport, 'pointercancel', release);
  listen(viewport, 'click', event => {
    if (performance.now() < suppressClickUntil) { event.preventDefault(); event.stopPropagation(); }
  }, { capture: true });
  listen(viewport, 'keydown', event => {
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault();
      step(event.key === 'ArrowRight' ? 1 : -1);
    }
  });
  const next = module.querySelector('[data-mr-next]'), prev = module.querySelector('[data-mr-prev]');
  if (next) listen(next, 'click', () => step(1));
  if (prev) listen(prev, 'click', () => step(-1));
  const sizeObserver = new ResizeObserver(resize);
  sizeObserver.observe(viewport);
  const visibilityObserver = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; });
  visibilityObserver.observe(module);
  resize();
  frame = requestAnimationFrame(tick);
  madridRails.set(module, {
    select(index) { selected = true; moveTo(index * width, true); },
    deselect() { selected = false; },
    destroy() { cancelAnimationFrame(frame); signal.abort(); sizeObserver.disconnect(); visibilityObserver.disconnect(); }
  });
}
document.addEventListener('shopify:block:select', event => {
  const module = event.target.closest('.mr-rail');
  const panel = event.target.closest('.mr-rail-panel');
  if (module && panel) madridRails.get(module)?.select(Number(panel.dataset.mrRailIndex));
});
document.addEventListener('shopify:block:deselect', event => madridRails.get(event.target.closest('.mr-rail'))?.deselect());
document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.mr-rail').forEach(module => madridRails.get(module)?.destroy()));

function bindMadrid(root=document){root.querySelectorAll('.mr-module').forEach(module=>{if(module.dataset.ready)return;module.dataset.ready='1';if(module.dataset.mrModule==='rail')bindMadridRail(module);const track=module.querySelector('[data-mr-slides]');if(track){const panels=Array.from(track.children);const go=i=>{i=(i+panels.length)%panels.length;track.scrollTo({left:panels[i].offsetLeft-track.offsetLeft,behavior:'instant'});};module.querySelectorAll('[data-mr-index]').forEach(b=>b.addEventListener('click',()=>go(+b.dataset.mrIndex)));const current=()=>Math.round(track.scrollLeft/(panels[0].getBoundingClientRect().width||1));module.querySelector('[data-mr-next]')?.addEventListener('click',()=>go(current()+1));module.querySelector('[data-mr-prev]')?.addEventListener('click',()=>go(current()-1));track.addEventListener('scroll',()=>{const i=current();module.querySelectorAll('[data-mr-index]').forEach((b,n)=>b.setAttribute('aria-current',String(n===i)));const count=module.querySelector('[data-mr-count]');if(count)count.textContent=(i+1)+' / '+panels.length;});}const form=module.querySelector('.mr-product-form');if(form){const variants=JSON.parse(form.querySelector('[data-mr-variants]').textContent);const submit=form.querySelector('[name=add]');form.addEventListener('change',()=>{const opts=Array.from(form.querySelectorAll('fieldset')).map(f=>f.querySelector(':checked')?.value);const v=variants.find(v=>v.options.every((o,i)=>o===opts[i]));form.querySelector('[name=id]').value=v?.id||'';submit.disabled=!v?.available;if(v)module.querySelector('[data-mr-price]').textContent=new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:window.Shopify.currency.active}).format(v.price/100);});form.addEventListener('submit',async e=>{e.preventDefault();submit.disabled=true;const status=form.querySelector('[role=status]');try{const drawer=document.querySelector('cart-drawer');const body=new FormData(form);if(drawer){body.append('sections',drawer.getSectionsToRender().map(s=>s.id).join(','));body.append('sections_url',location.pathname);}const res=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',body});const data=await res.json();if(!res.ok)throw Error(data.description);if(drawer){drawer.classList.remove('is-empty');drawer.renderContents(data);}else location.href=window.Shopify.routes.root+'cart';status.textContent='';}catch(err){status.textContent=err.message;}finally{submit.disabled=false;}})}})}bindMadrid();document.querySelectorAll('[data-mr-native-buy]').forEach(b=>b.addEventListener('click',()=>document.querySelector('product-info product-form button[name=add]')?.click()));document.addEventListener('shopify:section:load',e=>bindMadrid(e.target));

  } catch(e) { console.error(e); }
})();
})();
